'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('otppAlert', function() {
  return {
    restrict: 'E',
    templateUrl: 'scripts/directives/otpp-alert/otpp-alert.prt.html',
    scope: {
      alertState: '=',
      alertMessageKey: '='
    },
    controller: 'AlertController'
  };
});

MemberApp.controller('AlertController', function($scope, $rootScope, $translate, $q) {
  $scope.alertMessage = '';
  $scope.isVisible = false;

  $scope.getAlertStyle = function(alertState) {
    if (alertState === 'error') {
      return 'alert-danger';
    }
    if (alertState === 'success') {
      return 'alert-success';
    }
    throw new Error('Unexpected alert type ' + alertState);
  };

  $scope.handleAlertStyle = function(newMessage) {
    if (newMessage) {
      $scope.isVisible = true;
      $scope.alertCSSName = $scope.getAlertStyle($scope.alertState);
    } else {
      $scope.isVisible = false;
    }
  };

  $scope.updateAlert = function(alertState) {
    if (!alertState) {
      $scope.isVisible = false;
      $scope.alertMessage = '';
      return;
    }

    //handle translation
    return $translate($scope.alertMessageKey).then(function(translatedValue) {
      $scope.alertMessage = translatedValue;
      $scope.handleAlertStyle(alertState);
    }, function() {
      return $q.reject('No translation key found [' + $scope.alertMessageKey + ']');
    });
  };

  $scope.$watch('alertState', function() {
    $scope.updateAlert($scope.alertState);
  });
  $scope.$watch('alertMessageKey', function() {
    $scope.updateAlert($scope.alertState);
  });

  $rootScope.$on('$translateChangeSuccess', function() {
    if (!$scope.alertMessageKey) {
      return;
    }

    $translate($scope.alertMessageKey).then(function(translatedValue) {
      $scope.alertMessage = translatedValue;
    });
  });

});
